/** Widget types an owner can pick on their Announcement page, in the order the picker lists them. */
export const WIDGET_TYPE_OPTIONS = [
	{ value: "Event", label: "Event", desc: "RSVP, countdown & details" },
	{ value: "PictureFrame", label: "Polaroids", desc: "Photo frames" },
	{ value: "ImageGallery", label: "Image Slideshow", desc: "Photo carousel" },
	{ value: "TextBox", label: "Textbox", desc: "Add text content" },
	{ value: "Poll", label: "Poll", desc: "Ask your guests", featureFlag: "showPollsWidget" },
];

export const getAvailableWidgetOptions = (featureFlags) =>
	WIDGET_TYPE_OPTIONS.filter((option) => !option.featureFlag || featureFlags?.[option.featureFlag]);
